import { render, staticRenderFns } from "./statusIndicatorWithWords.vue?vue&type=template&id=3ec1a4ee&scoped=true"
import script from "./statusIndicatorWithWords.vue?vue&type=script&lang=js"
export * from "./statusIndicatorWithWords.vue?vue&type=script&lang=js"
import style0 from "./statusIndicatorWithWords.vue?vue&type=style&index=0&id=3ec1a4ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec1a4ee",
  null
  
)

export default component.exports